import { memo, useEffect, useState } from "react";
import { container } from "tsyringe";
import { useProjectId } from "hooks/useProjectId";
import ChoiceResponseResource from "common/resources/Choice/ChoiceResponseResource";
import VoteResultResponseResource from "common/resources/Vote/VoteResultResponseResource";
import ResultOption from "./ResultIOption";
import ChoiceService from "services/projects/ChoiceService";
import { VoteWithResults } from "hooks/useVote";

const choiceService = container.resolve(ChoiceService);

type IProps = {
	choice: ChoiceResponseResource;
	voteWithResults: VoteWithResults;
	showResults: true;
};

function getResultPercentage(choiceId: string, results: ReadonlyArray<VoteResultResponseResource>) {
	return results.find((result) => result.choiceId === choiceId)?.percentage ?? 0;
}

const formatPercentage = (percentage: number) => {
	return `${percentage.toFixed(2)}%`;
};

function VoteOption(props: IProps) {
	const { projectId } = useProjectId();
	const [imageUrl, setImageUrl] = useState<string | null>(null);

	useEffect(() => {
		if (!props.choice.image) return;
		choiceService
			.downloadImage(projectId, props.voteWithResults.question.id, props.choice.id)
			.then((blob) => {
				setImageUrl(URL.createObjectURL(blob));
			})
			.catch((error) => {
				console.error("Error downloading image:", error);
			});
	}, [projectId, props]);

	const percentage = formatPercentage(getResultPercentage(props.choice.id, props.voteWithResults.results));

	return props.showResults && <ResultOption percentage={percentage} imageUrl={imageUrl} choice={props.choice} />;
}

export default memo(VoteOption);
